import { buildCourseSsoUrl, openCourseUrl } from '@/common/js/courseSso';

export default {
  getScreenHeight(){
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    return screenHeight;
  },
  getScreenWidth(){
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return screenWidth;
  },
  /**
   * 推算 Element 栅格列 span（24 栅格制）。
   * @param {number} [basisWidth] 基准宽度（px）。不传则使用视口宽度，适用于首页等全宽内容区；
   *   传入课程列表容器 clientWidth 时，可与左侧栏等占位后的实际内容宽对齐。
   */
  calculateSpan(basisWidth) {
    const screenWidth =
      typeof basisWidth === 'number' && basisWidth > 0 && Number.isFinite(basisWidth)
        ? basisWidth
        : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const unit = parseInt(screenWidth / 150, 10);
    const divisor = unit < 1 ? 1 : unit;
    let spanValue = 24 / divisor;
    if (spanValue % 2 != 0) {
      spanValue += 1;
    }

    var resultValue = spanValue;
    if (spanValue <= 12) {
      resultValue = 24;
    }
    if (spanValue <= 8) {
      resultValue = 12;
    }
    if (spanValue < 6) {
      resultValue = 6;
    }
    if (spanValue < 4) {
      resultValue = 4;
    }
    return resultValue;
  },
  checkScreenSize() {
    window.isH5 = window.matchMedia('(max-width: 600px)').matches;
    return window.isH5
  },
  getImageSource(img){
    if (img.startsWith("data:image")){
      return img
    }else{
      return window.baseURL + img
    }
  },
  windowOpen(url) {
   window.open(url, '_blank');
  },
  buildCourseSsoUrl,
  openCourseUrl
};
